module.exports = {
  "opsMap": {},
};



// WEBPACK FOOTER //
// ./src/i18n/opsMap/zh-CN.js